/**
 * Alert
 */

// Module Dependencies
import 'protons';

// Module template
import './_alert.twig';
import './_alert.css';

export const name = 'alert';

export function disable() {}

export function enable() {
  function initClose(divId) {
    const divElement = document.getElementById(divId);

    if (divElement) {
      const allElements = divElement.querySelectorAll('*');
      allElements.forEach((element) => {
        element.addEventListener('click', (event) => {
          const clickedElement = event.target;
          const parentElement = clickedElement.closest('.alert');
          parentElement.classList.remove('show');
        });
      });
    }
  }

  // Usage example:
  initClose('alert'); // Replace 'myDiv' with your actual div ID
}
export default enable;
